require("./main")
require("./demo_customizer")
// require("./main_rentals")
// require("./popup_chat_trigger_demo")
require("./dataTables.bootstrap4.min")
